module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分组"
    }
  }, [_c('el-select', {
    staticClass: "group",
    model: {
      value: (_vm.form.group),
      callback: function($$v) {
        _vm.form.group = $$v
      },
      expression: "form.group"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "all"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "区域一",
      "value": "shanghai"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "区域二区域二区域二区域二",
      "value": "beijing"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请求类型"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.form.type = $$v
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "GET"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "POST"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "DELETE"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "PUT"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "链接"
    }
  }, [_c('el-input', {
    staticClass: "url",
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.form.url = $$v
      },
      expression: "form.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ApiAdd'
        })
      }
    }
  }, [_vm._v("创建")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "链接",
      "width": "180"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.url))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "group",
      "label": "分组"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'ApiEdit',
                params: {
                  id: scope.row.url
                }
              })
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          }
        }, [_vm._v("文档")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          }
        }, [_vm._v("删除")])]
      }]
    ])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-807bfef8!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
// module id = 98
// module chunks = 1